import { render, staticRenderFns } from "./ControlSidebarSlot.vue?vue&type=template&id=0f024451"
import script from "./ControlSidebarSlot.vue?vue&type=script&lang=js"
export * from "./ControlSidebarSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports